import { frontendURL } from '../../../helper/URLHelper';
import {
  LAIS_AGENT_PERMISSIONS,
  laisCanonicalRedirect,
} from '../laisRouteHelpers';

const meta = { permissions: LAIS_AGENT_PERMISSIONS };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/mensagens-clientes'),
    name: 'lais_inquiries_index',
    redirect: laisCanonicalRedirect('lais_leads_index', {
      query: { view: 'mensagens' },
    }),
    meta,
  },
];
